import { gql } from "@apollo/client";

export const COMMISSARY_REPORT_QUERY = gql`
  query commissary_report($where: order_commissary_bool_exp) {
    order_commissary(where: $where, order_by: { created_at: desc }) {
      id
      event_id
      vendor_id
      status
      notes
      organizer_notes
      rejection_reason
      subtotal
      tax
      total
      items
      sms_notify
      created_at
      updated_at
      fulfilled_at
      vendor {
        id
        name
        poc_name
        poc_phone
      }
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;
